export const PASSWORD_RESET_REQUIRED_CODE = 'password_reset_required';
export const REQUIRED_PASSWORD_CHANGE_PATH = '/cambiar-contrasena';
export const PASSWORD_RESET_REQUIRED_STORAGE_KEY = 'passwordResetRequired';

export function isPasswordResetRequired(value) {
  return value === true || value === 1 || value === '1';
}

export function isPasswordChangeConfirmed(payload) {
  return payload?.password_reset_required === false;
}

export function isMobileCustomerPath(currentPath = '') {
  return typeof currentPath === 'string' && currentPath.startsWith('/m/');
}

export function getPasswordResetRecovery({ status, code } = {}) {
  if (status === 403 && code === PASSWORD_RESET_REQUIRED_CODE) {
    return 'required';
  }

  return 'ignore';
}

export function getPasswordResetNavigation({ status, code, currentPath = '' } = {}) {
  if (getPasswordResetRecovery({ status, code }) !== 'required') {
    return {
      action: 'ignore',
      path: null,
    };
  }

  if (currentPath === REQUIRED_PASSWORD_CHANGE_PATH) {
    return {
      action: 'stay',
      path: REQUIRED_PASSWORD_CHANGE_PATH,
    };
  }

  if (isMobileCustomerPath(currentPath)) {
    return {
      action: 'ignore',
      path: null,
    };
  }

  return {
    action: 'redirect',
    path: REQUIRED_PASSWORD_CHANGE_PATH,
  };
}

export function buildPasswordResetClientState(navigation) {
  if (!navigation || navigation.action === 'ignore') {
    return null;
  }

  return {
    flag: '1',
    redirectTo: navigation.action === 'redirect' ? navigation.path : null,
  };
}
